module.exports = __webpack_public_path__ + "img/trailer.f30a9e50.svg";